import { CreatorRegistrationDataService, FeatureFlagName } from '@api'
import { useUnit } from 'effector-react'
import { useQuery } from 'react-query'
import { useLocation, useNavigate } from 'react-router'

import { $account } from '@/models/account.ts'
import { $availableFeatures } from '@/models/feature-flags'
import { AppRoutes } from '@/utils/constants'
import { isFeatureAvailable as isFeatureAvailableUtil } from '@/utils/featureFlags'

export const QuestionnaireRoot = () => {
  const location = useLocation()
  const account = useUnit($account)
  const navigate = useNavigate()
  const availableFeatures = useUnit($availableFeatures)

  const isChattingPage = location.pathname.startsWith(
    AppRoutes.Chatting.Base.asUrl(),
  )
  const isQuestionnaireRoute = location.pathname.startsWith(
    AppRoutes.Questionnaire.asUrl(),
  )
  const isFeatureAvailable = isFeatureAvailableUtil(
    availableFeatures,
    FeatureFlagName.ONBOARDING,
    false,
  )

  useQuery(
    ['check-should-questionnaire-filled', isFeatureAvailable],
    () => CreatorRegistrationDataService.shouldProvideRegistrationData(),
    {
      enabled: !!account?.owner && !isChattingPage && isFeatureAvailable,
      onSuccess: (shouldBeFilled) => {
        if (shouldBeFilled) {
          navigate(AppRoutes.Questionnaire.asUrl())

          return
        }
        if (isQuestionnaireRoute) {
          navigate(AppRoutes.Overview.asUrl())
        }
      },
    },
  )

  return null
}
